// The sticky top nav bar

import select from '../utils/select';
import selectAll from '../utils/select-all';

const appNav = document.getElementById('app-nav');
const { height } = appNav.getBoundingClientRect();
const appNavHeight = Math.round(height) + 10;

const appNavJumps = selectAll('.navbar__item a', appNav);

// These are for anchor links so that they also take into account the height of the sticky bar
const anchorJumps = selectAll('a.anchor', document);

appNavJumps.concat(anchorJumps).forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    const target = select(e.target.getAttribute('href'));

    // var current = appNav.getElementsByClassName('active-nav');

    // current[0].className = current[0].className.replace(' active-nav', '');

    // var path =
    //   e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
    // path[1].className += ' active-nav';

    window.scrollTo(
      0,
      window.pageYOffset + target.getBoundingClientRect().top - appNavHeight
    );
  });
});